import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter, Inject,
  Input,
  Output
} from "@angular/core";
import {TeamModel} from "../../../models/team.model";
import {TeamsHttpService} from "../../services/teams-http.service";

require('./teams-table-row.scss');
@Component({
  standalone: false,
  selector: 'app-teams-table-row',
  templateUrl: './teams-table-row.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TeamsTableRowComponent {

  @Input() team: TeamModel;
  @Input() allowEdit: boolean;
  @Input() allowDelete: boolean;
  @Output() editTeamEvent = new EventEmitter<TeamModel>();
  @Output() deleteTeamEvent = new EventEmitter<TeamModel>();


  public agentIds: string[];
  public isLoadingAgentIds: boolean;

  constructor(@Inject(TeamsHttpService) private teamsHttpService: TeamsHttpService) {
  }


  getTeamAgentIds() {
    if (!!this.agentIds || this.isLoadingAgentIds) {
      return;
    }
    this.isLoadingAgentIds = true;
    this.teamsHttpService.getTeamsAgentIds([this.team.id]).subscribe({
      next: (agentIds) => {
        this.agentIds = agentIds;
      },
      error: () => {
        this.isLoadingAgentIds = false;
      },
      complete: () => {
        this.isLoadingAgentIds = false;
      }
    })
  }

}
